
import router from "@/router";
import { api } from "@/services/Api";
import { useStore } from "@/store";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  async setup() {
    const store = useStore();
    const { t } = useI18n();

    const priceTypes = computed(() => store.state.priceTypes);
    const currentLanguageId = computed(() => store.state.currentLanguageId);
    const clubId = computed(() => {
      return store.state.order?.businessClientId || 0;
    });
    const isClub = computed(() => clubId.value > 0);

    function addMissingPriceLists() {
      return [
        {
          available: true,
          id: 3,
          name: "FIT Tourist",
          disabled: true,
        },
        {
          available: true,
          id: 5,
          name: "Group Tourist",
          disabled: true,
        },
      ];
    }

    const priceTypesToView = computed(() => {
      var result = [...priceTypes.value, ...addMissingPriceLists()];
      return result.sort((a, b) => a.id - b.id);
    });

    async function selectPriceType(id: number) {
      if (store.state.order.priceType == id) {
        return;
      }

      if ([...addMissingPriceLists()].some((x) => x.id == id)) {
        return;
      }

      if (!store.state.priceTypes.find(x => x.id == id)?.available) {
        return;
      }

      if (store.state.order.products.length == 0) {
        const priceResponse = await api
          .withLoader()
          .getProductPrices(
            store.state.selectedProduct?.productId ?? 0,
            id,
            store.state.selectedProduct?.date ? moment(store.state.selectedProduct?.date).format("YYYY-MM-DD") : "",
            clubId.value
          );

        if (priceResponse.data?.prices?.some((x) => x)) {
          store.state.order.priceType = id;
          return;
        }
        await Swal.fire({
          text: t('alert.no-available-prices '),
          icon: "error",
          customClass: {
            confirmButton: "popup-bookit-button",
          },
          confirmButtonText: t("cashier.label.ok"),
          buttonsStyling: false,
        });

        return;
      }

      const result = await Swal.fire({
        text: t('cashier.alert.change-price-type'),
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: t("cashier.label.no"),
        confirmButtonText: t("cashier.label.yes"),
        customClass: {
          confirmButton: "popup-bookit-button",
          cancelButton: "close-button-wrapper popup-bookit-button",
        },
        buttonsStyling: false,
      });

      if (result.isConfirmed) {
        store.dispatch("setOrderPriceType", id);
        if (isClub.value) {
          router.replace({
            name: "clubProducts",
            params: {
              clubId: clubId.value,
            },
          });
        }
        else {
          router.replace({ name: "select-products" });
        }
      }
    }

    return { priceTypesToView, selectPriceType, currentLanguageId };
  },
});
